import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const SubMenuActiveLink = ({ children, activeMenu = false, ...props }) => {
  const [active, setActive] = useState(false);
  const child = React.Children.only(children);

  useEffect(() => {
    if (activeMenu) setActive(true);
    else setActive(false);
  }, [activeMenu]);
  return (
    <Link {...props} to={props.href} className={active ? 'active' : ''}>
      {React.cloneElement(child)}
    </Link>
  );
};

SubMenuActiveLink.propTypes = {
  activeMenu: PropTypes.bool
};

const ActiveLink = ({
  children,
  activeClassName,
  forceselected,
  disabledlink,
  ...props
}) => {
  const location = useLocation();
  const child = React.Children.only(children);
  const childClassName = child.props.className || null;
  const className =
    location.pathname === props.href || forceselected // forceselected for limited access MD user only
      ? `${childClassName} ${activeClassName}`.trim()
      : childClassName;

  return disabledlink ? (
    <a {...props} className={className} style={{ cursor: 'pointer' }}>
      {React.cloneElement(child)}
    </a>
  ) : (
    <Link {...props} to={props.href} className={className}>
      {React.cloneElement(child)}
    </Link>
  );
};

ActiveLink.propTypes = {
  activeClassName: PropTypes.string.isRequired
};

export { ActiveLink, SubMenuActiveLink };
